var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1BackoeLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 33.58v-9.33L54.16 10H36L21 21.81V36H9v4.89L17.75 48H31v3H13.37a6 6 0 100 12h38.86a6 6 0 100-12H34v-3h17V37.13a18.78 18.78 0 00-6.27-13.63l-.59-.5H36v13H25V23.79L37.41 14h14.76L61 25.65v15.18L54.91 47H62a5.21 5.21 0 00.81-.07 7.1 7.1 0 006.21-7C69 37.14 65 33.58 65 33.58zM40 27h3a14.44 14.44 0 014 8.8v.2h-7v-9zm12.25 28a2 2 0 01.08 4H13.27a2 2 0 01.08-4h38.9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Backoe_loader.4d892000.svg";
export { SvgI1BackoeLoader as ReactComponent };